function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6124 4.77704C14.4377 4.73304 11.2377 4.0957 11.2377 4.0957L10.6831 4.60637L10.3351 5.23304L10.0817 5.95704L9.45107 6.38237L8.78707 6.81304L8.17773 9.93303C8.17773 9.93303 14.3057 9.0957 14.3937 8.80904C14.4817 8.52237 14.6124 4.77704 14.6124 4.77704Z",
  fill: "url(#paint0_radial)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5507 20.9374H18.7027V18.0681C18.7027 17.8854 18.5561 17.7414 18.3774 17.7334H8.2494C8.0694 17.7414 7.92407 17.8854 7.92407 18.0681V20.9374H6.0774C5.65207 20.9374 5.30273 21.2867 5.30273 21.7174V24.8867C5.30273 25.3174 5.65073 25.6654 6.0774 25.6654H20.5507C20.9761 25.6654 21.3227 25.3161 21.3227 24.8867V21.7174C21.3227 21.2867 20.9761 20.9374 20.5507 20.9374Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9908 8.80957H12.3135V20.1109H15.9908V8.80957Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.9456 3.18129C21.6082 2.19062 20.4336 0.877287 19.5456 0.473287C19.4122 0.411954 19.2696 0.361287 19.1242 0.34262C18.7256 0.289287 18.5736 0.485287 18.7136 0.866621C18.7976 1.09462 18.9016 1.31329 18.9896 1.54129C19.2456 2.21729 19.1522 2.67462 18.5949 3.13195C18.0162 3.60662 17.3589 3.98129 16.6042 4.03195C16.2096 4.05995 15.7736 3.95729 15.4082 3.79595C14.9456 3.59329 14.9709 3.40395 15.3602 3.06795C15.7442 2.73595 16.1416 2.40529 16.4682 2.01995C16.8389 1.58129 16.7536 1.25862 16.2522 0.963954C15.9629 0.793287 15.6589 0.646621 15.3509 0.513287C14.9096 0.32662 14.6989 0.439954 14.4949 0.87862C14.3202 1.25595 14.1616 1.66395 13.8962 1.96662C13.2576 2.69862 12.6936 3.53862 11.6789 3.82662C11.5349 3.86662 11.4109 3.98795 11.2389 4.09595C11.4389 4.23995 11.6002 4.35995 11.7642 4.47062C11.9722 4.61195 12.0696 4.79195 11.9202 5.01729C11.7656 5.24795 11.5589 5.20395 11.3576 5.06929C11.1389 4.92262 10.9242 4.77195 10.6829 4.60662C10.5522 4.84129 10.4442 5.03462 10.3349 5.23329C10.5682 5.40129 10.7962 5.51462 10.9482 5.69329C11.0549 5.81729 11.1402 6.06795 11.0856 6.19995C10.9842 6.45329 10.7416 6.40262 10.5389 6.27462C10.3816 6.17462 10.2322 6.06395 10.0802 5.95862C9.86423 6.10395 9.66957 6.23595 9.44956 6.38395C9.67623 6.55062 9.8669 6.70129 10.0669 6.83595C10.2816 6.97995 10.4309 7.15995 10.2522 7.40129C10.0802 7.63195 9.85756 7.56795 9.64823 7.41729C9.36023 7.20529 9.06157 7.00395 8.7869 6.81329C7.42157 7.63195 6.3349 8.70795 5.24023 9.78529C4.50423 10.508 3.67223 11.1253 2.87223 11.7773C2.3109 12.2333 1.70557 12.6386 1.16957 13.1226C0.945567 13.3226 0.7949 13.6533 0.709567 13.9533C0.568234 14.4613 0.7829 14.8053 1.29223 14.9266C1.64157 15.0093 2.0069 15.0653 2.36423 15.0586C2.87357 15.048 3.37757 15.012 3.87757 14.956C4.12557 15.6893 4.4549 15.9786 4.86957 15.844C5.56423 15.62 5.69223 15.4173 5.46557 14.7C6.00157 14.5893 6.53223 14.4533 7.06023 14.296C7.42023 15.1133 7.62957 15.212 8.27223 14.9386C8.72023 14.7493 8.80023 14.4466 8.5469 13.7786C9.04557 13.5826 9.55223 13.364 10.1029 13.148L10.1109 13.1453C10.4442 13.8666 10.6616 13.9426 11.2749 13.6826C11.7176 13.4973 11.8002 13.2 11.5589 12.5506L15.0656 11.1106L15.0669 11.1093C15.5869 10.904 16.1056 10.696 16.6242 10.4866C16.8122 10.824 16.8989 11.228 17.3109 11.2613C17.5976 11.2853 18.0136 11.128 18.1802 10.9066C18.4242 10.5853 18.2336 10.2253 18.1282 9.87729C18.4216 9.75995 18.7149 9.63995 19.0082 9.51995C19.2189 9.43462 19.4322 9.34795 19.6442 9.26262C19.8429 9.60395 19.9229 10.0293 20.3469 10.0653C20.6349 10.0893 21.0482 9.93195 21.2162 9.71062C21.4682 9.37862 21.2589 9.00662 21.1562 8.64929C21.6229 8.45862 22.0909 8.26795 22.5549 8.07729C23.0856 7.85862 23.4309 7.37862 23.3042 6.96395C23.0149 6.02262 22.6829 5.09595 22.3629 4.14929L21.9456 3.18129Z",
  fill: "url(#paint3_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.60449 8.67762C9.60449 8.67762 12.8872 8.67762 13.4125 9.93362C13.9378 11.1896 18.2058 8.21496 18.2058 8.21496C18.2058 8.21496 16.1712 6.03362 14.6605 5.96696C13.1498 5.90162 9.60449 8.67762 9.60449 8.67762Z",
  fill: "url(#paint4_radial)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3179 18.9883H9.30859V24.2096H17.3179V18.9883Z",
  fill: "url(#paint5_radial)"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.5014 4.4937) rotate(90) scale(5.43933 6.11742)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE148"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 5.30273,
  y1: 17.7334,
  x2: 9.08351,
  y2: 29.466,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA20"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E49700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 12.3135,
  y1: 8.80957,
  x2: 19.694,
  y2: 12.4996,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA20"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E49700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 0.666992,
  y1: 0.333984,
  x2: 10.1115,
  y2: 21.4949,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA20"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E49700"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.7105 6.25744) rotate(90) scale(3.98551 8.17727)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE148"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.2009 19.3443) rotate(90) scale(4.86534 7.61446)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE148"
})));

var SvgGoldenBoot = function SvgGoldenBoot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoldenBoot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/goldenBoot.212d2324.svg";
export { ForwardRef as ReactComponent };